import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import LicensesInUseList from "../Components/LicensesInUseList/index";
import Core from "../Core";
import ButtonBack from "../Components/ButtonBack";

class OfflineLicensesInUseListPage extends Component {

    onAddClicked() {
        const { stores, customerId } = this.props;

        const customer = stores.data.CustomersStore.findById(customerId);
        if (customer) {
            const hash = `#offline-licenses-in-use-detail?customerId=${customer.Id}`;
            window.location.hash = hash;
        }
    }

    render() {
        const { stores, customerId } = this.props;

        const customer = stores.data.CustomersStore.findById(customerId);

        let customerName = "";
        if (customer) customerName = customer.Name;

        const offlineLicensesInUse = stores.data.LicensesInUseStore.findByOffline();

        return (
            <div>
                <div className="row">
                    <ButtonBack />
                </div>

                <div className="row">
                    <h1>Offline licenses for {customerName}</h1>
                </div>

                <div className="row">
                    <div className="pull-right">
                        <Core.Components.Buttons.Add
                            onClick={this.onAddClicked.bind(this)}
                        />
                    </div>
                </div>

                <div className="row">
                    <LicensesInUseList licensesInUse={offlineLicensesInUse} />
                </div>
            </div>
        );
    }
}

export default inject("stores")(observer(OfflineLicensesInUseListPage));



// WEBPACK FOOTER //
// ./src/Pages/OfflineLicensesInUseListPage.js